module.exports = __webpack_public_path__ + "img/symbol_0.2de917b9.png";